export const serverErrorMessage =
  "Please refresh and try again. If the issue persists, please contact the admin.";

export const sessionAutoRefreshTiming = 30000; // 60000 milliseconds = 1 minute

export const sessionReportMaxAttemptCount = 20;
